import { render } from "./EmployeeApprovalsRejected.vue?vue&type=template&id=fd8a417c&scoped=true"
import script from "./EmployeeApprovalsRejected.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsRejected.vue?vue&type=script&lang=js"

import "./EmployeeApprovalsRejected.vue?vue&type=style&index=0&id=fd8a417c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd8a417c"]])

export default __exports__